import {
    FormStepper,
    EntityFormGeneralDataSection,
    EntityFormCaracteristicasSection,
} from "base/component/form";
import {
    CaptacionFormGeneralDataFields,
    CaptacionFormCaracteristicasFields,
    CaptacionFormLocationFields,
} from ".";
import Box from "@mui/material/Box";

const CaptacionCreationForm = ({onSubmit, onCancel = null}) => {
    const steps = ["Datos xerais", "Características"];

    const stepComponents = [
        <EntityFormGeneralDataSection
            fields={<CaptacionFormGeneralDataFields />}
            location={<CaptacionFormLocationFields isCreationForm={true} />}
        />,
        <EntityFormCaracteristicasSection
            fields={<CaptacionFormCaracteristicasFields />}
        />,
    ];
    return (
        <Box component="form" width="100%" mt={4}>
            <FormStepper
                onSubmit={onSubmit}
                onCancel={onCancel}
                steps={steps}
                stepComponents={stepComponents}
            />
        </Box>
    );
};

export default CaptacionCreationForm;
